import { Link } from "react-router-dom";

/**
 * Renders post / comment / chat text with:
 *  - @mentions → neon-green link
 *  - #hashtags → electric-blue link
 *  - bare URLs → blue external link
 */
export default function RichText({ text }) {
  if (!text) return null;
  const parts = text.split(/(\s+)/);
  return (
    <>
      {parts.map((seg, i) => {
        if (seg.startsWith("#")) {
          const tag = seg.slice(1).replace(/[^A-Za-z0-9_]/g, "");
          if (tag) {
            return (
              <Link
                key={i}
                to={`/tag/${tag.toLowerCase()}`}
                className="text-[#00aaff] hover:text-[#39ff14] font-medium"
                data-testid={`hashtag-${tag.toLowerCase()}`}
              >
                #{tag}
              </Link>
            );
          }
        }
        if (seg.startsWith("@")) {
          const handle = seg.slice(1).replace(/[^A-Za-z0-9_]/g, "");
          if (handle) {
            return (
              <Link
                key={i}
                to={`/u/${handle}`}
                className="text-[#39ff14] hover:text-[#00aaff] font-medium"
                data-testid={`mention-link-${handle.toLowerCase()}`}
              >
                @{handle}
              </Link>
            );
          }
        }
        if (/^https?:\/\//i.test(seg)) {
          return (
            <a key={i} href={seg} target="_blank" rel="noopener noreferrer" className="text-[#00aaff] underline underline-offset-2 csc-break-anywhere">
              {seg}
            </a>
          );
        }
        return <span key={i}>{seg}</span>;
      })}
    </>
  );
}
